import React, { useEffect } from 'react'
import pdfIcon from '../../assets/images/pdfIcons.svg'
import docIcon from '../../assets/images/docIcon.svg'
import firstine from '../../assets/icons/file-list.svg'
import user from '../../assets/icons/user.svg'
import stetho from '../../assets/icons/stethoscope.svg'
import first from '../../assets/icons/first-aid.svg'
import briefcase2 from '../../assets/icons/briefcase-2-line.svg'
import graduation from '../../assets/icons/graduation-cap-line.svg'
import suitcase from '../../assets/icons/suitcase-line.svg'
import firstKit from '../../assets/icons/first-aid-kit.svg'
import arrowgo from '../../assets/icons/arrowgo.svg'
import apiService from '../../services/apiService'
import alert from '../../assets/images/Icon (3).svg'
import { useParams } from "react-router-dom";
import ActionBar from '../../components/common/actioinBar/ActionBar'
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const DetailForm = ({ modal, restictapi, detailModal }) => {


    const [values, setValues] = React.useState()
    const [rejection, setRejection] = React.useState(false);
    const [rejectionReasonText, setRejectionReasonText] = React.useState("");
    const maxLength = 250;


    const navigate = useNavigate();
    const { id } = useParams();

    const fetchData = async (id) => {

        const response = await apiService.get(`/physician/showPhysician/${id}`);

        setValues(response?.physician)
    }



    const rejectionReason = async () => {
        try {
            const requestData = {
                reason: rejectionReasonText, // Use the rejection reason state
                action: "reject",
            };

            const response = await apiService.post(`/physician/physicianAction/${id}`, requestData);

            // Close the rejection modal
            setRejection(false);

            // Show a success message (assuming the response has a 'message' field)
            toast.success(response?.message, { toastId: "78" });
            setRejectionReasonText("")

            setTimeout(() => {
                navigate(`/practitioners`)
            }, 2000);
        } catch (error) {
            console.error("Error rejecting the physician:", error?.response?.data?.message);

            // Optionally, show an error message to the user
            toast.error(error?.response?.data?.message || "An error occurred while processing the rejection. Please try again.", { toastId: "190" });

        }
    };
    const Approve = async () => {
        try {
            const requestData = {
                // Use the rejection reason state
                action: "approve",
            };

            const response = await apiService.post(`/physician/physicianAction/${id}`, requestData);

            // Close the rejection modal


            // Show a success message (assuming the response has a 'message' field)
            toast.success(response?.message, { toastId: "198" });
            setRejectionReasonText("")

            setTimeout(() => {
                navigate(`/practitioners`)
            }, 2000);

        } catch (error) {


            // Optionally, show an error message to the user
            toast.error(error?.response?.data?.message || "An error occurred while processing the approval. Please try again.", { toastId: "11o" });

        }
    };

    const handleRejectionReasonChange = (e) => {
        setRejectionReasonText(e.target.value);
    };

    useEffect(() => {
        (restictapi) && fetchData(id || detailModal?.user?.physician?._id);


    }, [])


    return (


        <>

            {rejection && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-600 bg-opacity-50 z-50">
                    {/* Modal Container */}
                    <div className="bg-white rounded-lg p-6" style={{ width: "440px", height: "auto" }}>
                        {/* Header Section */}
                        <div className="flex  mb-4">
                            <img src={alert} alt="Rejection Image" className="w-16 h-16 object-cover rounded-full mr-4" />
                            <div>
                                <h2 className="text-xl font-semibold">Reason Of Rejection</h2>
                                <p className="text-gray-700 text-sm mb-4">
                                    Please confirm that you are submitting the reason for rejection. This action cannot be undone
                                </p>
                            </div>
                        </div>

                        {/* Textarea for Rejection Reason */}
                        <textarea
                            value={rejectionReasonText} // Bind the value to state
                            onChange={handleRejectionReasonChange}
                            className="w-full h-32 p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            placeholder="Write a reason..."
                            maxLength={maxLength}
                        ></textarea>
                        <div className="text-right text-sm text-gray-500">
                            {rejectionReasonText.length} / {maxLength} characters
                        </div>

                        {/* Modal Footer Buttons */}
                        <div className="mt-4 flex justify-end items-center space-x-2">
                            <button
                                className="border bg-[#FFFFFF] text-[#525866] border-gray-700 py-2 px-4  rounded-[8px]   focus:outline-none"

                                onClick={() => setRejection(false)} // Example close action
                            >
                                Dismiss
                            </button>
                            <button
                                onClick={() => rejectionReason()} // Handle submit action
                                className="bg-[#176448] text-white py-2 px-4 rounded-[8px]  focus:outline-none"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {modal && (<div className="flex w-full justify-center items-center  bg-gray-50">
                <ActionBar id={values?.request_number} onReject={() => setRejection(true)} onApprove={Approve} hide={values?.actionStatus} />
            </div>)}
            <div className={`${modal ? "p-5" : "p-0"}`}>
                <div className=" text-medium text-gray-500   rounded-lg w-full" id="profile" role="tabpanel" aria-labelledby="profile-tab">

                    <div className='border-t border-l'>

                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className='pl-4 flex  space-x-1 items-center'>
                                <div className=''>
                                    <img src={firstine} alt="License Icon" className="w-6 h-6 " />
                                </div>
                                <h3 className="label-medium pt-2">License Information</h3>
                            </div>
                        </div>

                        <div className=" pt-1 ml-4 ">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6 ">

                                <div className="lg:col-span-1 border-r">
                                    <div>
                                        <label className='inter-font2'>
                                            SCFHS License Number
                                        </label>
                                        <div className='text-[#0A0D14] inter-font'>
                                            {values?.licenseNumber}
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:col-span-1 ">
                                    <div className="flex flex-col items-center justify-center">
                                        <div>
                                            <label className='inter-font2'>
                                                SCFHS License Expiry Date
                                            </label>
                                            <div className='text-[#DF1C41] inter-font'>
                                                {values?.licenseExpiryDate}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:col-span-1">

                                </div>
                            </div>





                        </div>
                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className='pl-4 flex items-center space-x-1 '>
                                <div className=' '>
                                    <img src={user} alt="License Icon" className="w-6 h-6" />
                                </div>
                                <h3 className="label-medium pt-2" >Practitioner Information</h3>
                            </div>
                        </div>

                        <div className="pt-1 ml-4">
                            {/* First Row: Two Columns */}
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-6 pb-6">
                                <div className="lg:col-span-1 border-r">
                                    <label className='inter-font2'>Arabic Name</label>
                                    <div className="text-[#0A0D14] inter-font">{values?.firstArabicName}</div>
                                </div>
                                <div className="lg:col-span-1">
                                    <label className='inter-font2'>English Name</label>
                                    <div className="text-[#0A0D14] inter-font">{values?.user?.firstName}</div>
                                </div>
                            </div>
                            <hr />

                            {/* Second Row: Three Columns */}



                            {/* Third Row: Three Columns */}
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                                <div className="lg:col-span-1 border-r">
                                    <label className='inter-font2'>Nationality</label>
                                    <div className="text-[#0A0D14] inter-font">{values?.nationality}</div>
                                </div>
                                <div className="lg:col-span-1">
                                    <label className='inter-font2'>Identity #</label>
                                    <div className="text-[#0A0D14] inter-font">{values?.identityNumber}</div>
                                </div>
                                <div className="lg:col-span-1">

                                </div>
                            </div>
                            <hr />

                            {/* Fourth Row: Three Columns */}
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                                <div className="lg:col-span-1 border-r">
                                    <label className='inter-font2'>Date of Birth</label>
                                    <div className="text-[#0A0D14] inter-font">{values?.dateOfBirth}</div>
                                </div>
                                <div className="lg:col-span-1 border-r">
                                    <label className='inter-font2'>Place Of Birth</label>
                                    <div className="text-[#0A0D14] inter-font">{values?.placeOfBirth}</div>
                                </div>
                                <div className="lg:col-span-1">
                                    <label className='inter-font2'>Gender</label>
                                    <div className="text-[#0A0D14] inter-font">{values?.gender}</div>
                                </div>
                            </div>
                            <hr />
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                                <div className="lg:col-span-1 border-r">
                                    <label className='inter-font2'>Email</label>
                                    <div className="text-[#0A0D14] inter-font">{values?.user?.email}</div>
                                </div>
                                <div className="lg:col-span-1">
                                    <label className='inter-font2'>Phone Number</label>
                                    <div className="text-[#0A0D14] inter-font">{values?.user?.phoneNumber}</div>
                                </div>

                            </div>
                        </div>


                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className="flex items-center space-x-1 ">
                                <div className='pl-4'>
                                    <img src={stetho} alt="License Icon" className="w-6 h-6" />
                                </div>

                                <h3 className="label-medium pt-2">Personal Information</h3>
                            </div>
                        </div>

                        <div className=" pt-1 ml-4 ">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                                <div className="lg:col-span-1 border-r">
                                    <div>
                                        <label className='inter-font2'>
                                            Practitioner Type
                                        </label>
                                        <div className='text-[#0A0D14] inter-font'>
                                            {values?.practitionerType}
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:col-span-1">

                                    <div>
                                        <label className='inter-font2'>
                                            Practitioner Level
                                        </label>
                                        <div className='text-[#0A0D14] inter-font'>
                                            {values?.practitionerLevels}
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:col-span-1">


                                </div>



                            </div>
                        </div>

                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className="flex items-center space-x-1 ">
                                <div className='pl-4'>
                                    <img src={first} alt="License Icon" className="w-6 h-6 " />
                                </div>
                                <h3 className="label-medium pt-2">Medical Specialties</h3>
                            </div>
                        </div>

                        <div className="pt-1 ml-4 max-w-full">
                            <div className="flex gap-4 pt-7 pb-7 flex-wrap">
                                {values?.related_medical_specialties?.map((label, index) => (
                                    <span
                                        key={index}
                                        className="cursor-pointer leading-[16px] text-[12px] text-xs font-medium px-2.5 py-0.5 rounded border h-[24px] bg-[#2D9F75] text-[#fff] border-[#E2E4E9]"
                                    >
                                        {label?.name}
                                    </span>
                                ))}
                            </div>




                        </div>


                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className="flex items-center space-x-1 ">
                                <div className='pl-4'>
                                    <img src={briefcase2} alt="License Icon" className="w-6 h-6" />
                                </div>

                                <h3 className="label-medium pt-2">Job Information</h3>
                            </div>
                        </div>

                        <div className=" pt-1 ml-4 ">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">
                                <div className="lg:col-span-1 border-r">
                                    <div>
                                        <label className='inter-font2'>
                                            Current Job Organisation
                                        </label>
                                        <div className='text-[#0A0D14]'>
                                            {values?.currentJobOrganization}
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:col-span-1 border-r">

                                    <div>
                                        <label className='inter-font2'>
                                            Current Job Title
                                        </label>
                                        <div className='text-[#0A0D14]'>
                                            {values?.currentJobTitle}
                                        </div>
                                    </div>
                                </div>

                                <div className="lg:col-span-1">

                                    <div>
                                        <label className='inter-font2'>
                                            Hospital Preference
                                        </label>
                                        <div className='text-[#0A0D14]'>
                                            {values?.sites?.map((file) => {



                                                return (
                                                    <div
                                                        key={file.value} // Use a unique key, assuming `file.value` is unique
                                                        className="bg-[#F0F4F8] p-2 mb-2 rounded-md w-[185px] truncate"
                                                        title={file.label}


                                                    >
                                                        {file?.name}
                                                    </div>
                                                );

                                            })}



                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className="flex items-center space-x-1 ">
                                <div className='pl-4'>
                                    <img src={graduation} alt="License Icon" className="w-6 h-6" />
                                </div>

                                <h3 className="label-medium pt-2">Education Documents</h3>
                            </div>
                        </div>

                        <div className=" pt-1 ml-4 ">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">

                                {values?.educationDocument?.map((filep) => {


                                    const filePath = filep?.path || filep;

                                    const fileExtension = filePath?.split('.')?.pop()?.toLowerCase(); // Get the file extension from the path

                                    let fileIcon = null;

                                    // Check file type and assign the appropriate icon
                                    if (fileExtension === 'pdf') {
                                        fileIcon = pdfIcon; // Set PDF icon
                                    } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                                        fileIcon = docIcon; // Set DOC icon
                                    }

                                    const openFileInNewTab = () => {
                                        window.open(filePath, '_blank'); // Open the file in a new tab
                                    };

                                    return (
                                        <div
                                            key={filePath}
                                            className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                                            onClick={openFileInNewTab} // Open the file in a new tab on click
                                        >
                                            {fileIcon && (
                                                <img
                                                    src={fileIcon}
                                                    alt="file icon"
                                                    className="w-[40px] h-[40px] flex-shrink-0"
                                                />
                                            )}

                                            <div className="flex flex-col w-full">
                                                <div className="flex justify-between items-center w-full">
                                                    <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                                        {filePath} {/* Display the file path */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>





                        </div>
                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className="flex items-center space-x-1 ">
                                <div className='pl-4'>
                                    <img src={suitcase} alt="License Icon" className="w-6 h-6 " />
                                </div>

                                <h3 className="label-medium pt-2">Experience Documents</h3>
                            </div>
                        </div>

                        <div className=" pt-1 ml-4 ">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">



                                {values?.experienceDocument?.map((filep) => {


                                    const filePath = filep?.path || filep;

                                    const fileExtension = filePath?.split('.')?.pop()?.toLowerCase(); // Get the file extension from the path

                                    let fileIcon = null;

                                    // Check file type and assign the appropriate icon
                                    if (fileExtension === 'pdf') {
                                        fileIcon = pdfIcon; // Set PDF icon
                                    } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                                        fileIcon = docIcon; // Set DOC icon
                                    }

                                    const openFileInNewTab = () => {
                                        window.open(filePath, '_blank'); // Open the file in a new tab
                                    };

                                    return (
                                        <div
                                            key={filePath}
                                            className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                                            onClick={openFileInNewTab} // Open the file in a new tab on click
                                        >
                                            {fileIcon && (
                                                <img
                                                    src={fileIcon}
                                                    alt="file icon"
                                                    className="w-[40px] h-[40px] flex-shrink-0"
                                                />
                                            )}

                                            <div className="flex flex-col w-full">
                                                <div className="flex justify-between items-center w-full">
                                                    <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                                        {filePath} {/* Display the file path */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>





                        </div>
                        <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                            <div className="flex items-center space-x-1 ">
                                <div className='pl-4'>
                                    <img src={firstKit} alt="License Icon" className="w-6 h-6" />
                                </div>


                                <h3 className="label-medium pt-2">Practitioner Specialties Documents</h3>
                            </div>
                        </div>

                        <div className=" pt-1 ml-4 ">
                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">



                                {values?.practitionerSpecialtiesDocuments?.map((filep) => {


                                    const filePath = filep?.path || filep;
                                    const fileExtension = filePath?.split('.')?.pop()?.toLowerCase(); // Get the file extension from the path

                                    let fileIcon = null;

                                    // Check file type and assign the appropriate icon
                                    if (fileExtension === 'pdf') {
                                        fileIcon = pdfIcon; // Set PDF icon
                                    } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                                        fileIcon = docIcon; // Set DOC icon
                                    }

                                    const openFileInNewTab = () => {
                                        window.open(filePath, '_blank'); // Open the file in a new tab
                                    };

                                    return (
                                        <div
                                            key={filePath}
                                            className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                                            onClick={openFileInNewTab} // Open the file in a new tab on click
                                        >
                                            {fileIcon && (
                                                <img
                                                    src={fileIcon}
                                                    alt="file icon"
                                                    className="w-[40px] h-[40px] flex-shrink-0"
                                                />
                                            )}

                                            <div className="flex flex-col w-full">
                                                <div className="flex justify-between items-center w-full">
                                                    <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                                        {filePath} {/* Display the file path */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}

                            </div>





                        </div>

                        {(values?.requestAttachments.length > 0 &&
                            <>
                                <div className='bg-[#E2E4E9] h-[72px] flex items-center'>
                                    <div className="flex items-center space-x-1 ">
                                        <div className='pl-4'>
                                            <img src={arrowgo} alt="License Icon" className="w-6 h-6" />
                                        </div>
                                        <h3 className="label-medium pt-2">Additional Attachments</h3>
                                    </div>
                                </div>

                                <div className=" pt-1 ml-4 ">
                                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-6 pb-6">

                                        {values?.requestAttachments?.map((filep) => {


                                            const filePath = filep?.path || filep;


                                            const fileExtension = filePath?.split('.')?.pop()?.toLowerCase(); // Get the file extension from the path

                                            let fileIcon = null;

                                            // Check file type and assign the appropriate icon
                                            if (fileExtension === 'pdf') {
                                                fileIcon = pdfIcon; // Set PDF icon
                                            } else if (fileExtension === 'doc' || fileExtension === 'docx') {
                                                fileIcon = docIcon; // Set DOC icon
                                            }

                                            const openFileInNewTab = () => {
                                                window.open(filePath, '_blank'); // Open the file in a new tab
                                            };

                                            return (
                                                <div
                                                    key={filePath}
                                                    className="flex items-center space-x-1 border border-[#E2E4E9] w-full h-[72px] rounded-[12px] p-3"
                                                    onClick={openFileInNewTab} // Open the file in a new tab on click
                                                >
                                                    {fileIcon && (
                                                        <img
                                                            src={fileIcon}
                                                            alt="file icon"
                                                            className="w-[40px] h-[40px] flex-shrink-0"
                                                        />
                                                    )}

                                                    <div className="flex flex-col w-full">
                                                        <div className="flex justify-between items-center w-full">
                                                            <div className="font-medium leading-[20px] text-[14px] text-[#0A0D14] truncate max-w-[150px]">
                                                                {filePath} {/* Display the file path */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}

                                    </div>





                                </div>

                            </>
                        )}
                    </div>



                </div >
            </div >
        </>
    )
}

export default DetailForm


// <div className='flex justify-end items-center'>
//     <div className='flex items-center justify-between w-[300px]'>
//         <button type="button"
//             onClick={() => handleClick(4)}
//             class="w-[128px] h-[40px] text-[#007A63] flex justify-center items-center  border border-[#007A63]  focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm  text-center  [#007A63] [#007A63] :text-white">
//             <img src={arrowleft} alt='logo' style={{ paddingRight: '12px' }} />
//             Previous

//         </button>
//         <button type="submit"

//             // onClick={() => handleClick(5, validateForm, setTouched, setFieldTouched)}

//             className="text-white bg-[#007A63] flex justify-center items-center  focus:ring-4 focus:outline-none w-[128px] h-[40px] font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center">
//             Submit
//             <img src={IconArrow} alt="logo" style={{ paddingLeft: '12px' }} />
//         </button>

//     </div>
// </div>